

































































































































// tslint:disable-next-line:no-unused
import Vue, { CreateElement } from 'vue';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Prop, Component, Watch } from 'vue-property-decorator';
import { CSSStyleOptions } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
// tslint:disable-next-line:no-unused
import { DropdownStoreState } from './dropdown-store';
import DropdownThreeComponentRows from './dropdown-three-component-rows.vue';
import { SwScrollView } from '@sonicwall/unified-ui-framework/src/shared/sw-scroll-view';
import { State } from 'vuex-class';
import { RootStoreState } from '../../store';
import { defaultSelectedCustomer } from '@/modules/msw-products/products.store';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';

const cssPrefix = 'dropdown-three-component-unit';

@Component({
  components:{
    SwTextfield,
    SwScrollView,
    DropdownThreeComponentRows,
    SwIcon,
  },
})
export default class DropdownThreeComponentUnit extends SwExtendedVue{

  @State((state: RootStoreState) =>  state.DropdownStoreModule.searchValues)
  searchValues: DropdownStoreState['searchValues'];

  @State((state: RootStoreState) =>  state.DropdownStoreModule.recentlySearched)
  recentlySearched: DropdownStoreState['recentlySearched'];

  @Prop({ type: Array, default: () => { return []; } })
  customersList: any[];

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, default: false })
  highlight: boolean;

  filteredCustomers: any[] = [];
  currentPaginationIndex = 0;
  paginated: any = [];
  totalPaginationIndices = 0;
  showNextOrPrev = false;

  @Watch('searchValue')
  searchCustomer() {
    if (!this.$store.getters.isLargeCustomer || this.searchValue.length === 0) {
    //   this.filteredCustomers = this.customersList.filter(each => typeof each !== 'string' && each.productGroupName.toLowerCase()
    // .indexOf(this.searchValue.toLowerCase()) > -1);
      this.paginateLargeCustomers(this.customersList.filter(each => typeof each !== 'string' && each.productGroupName.toLowerCase()
    .indexOf(this.searchValue.toLowerCase()) > -1));
    }
  }

  @Watch('currentPaginationIndex')
  changePaginationIndex() {
    if (this.paginated[this.currentPaginationIndex].length > 0) this.filteredCustomers = this.paginated[this.currentPaginationIndex];
  }

  cssPrefix = cssPrefix;
  searchValue: string = '';
  isLargeCustomer: boolean = false;
  get searchStyle(): CSSStyleOptions {
    return {
      backgroundColor: '#363636',
      color: 'white',
    };
  }

  get getValuesFieldStyle(): CSSStyleOptions {
    return this.recentlySearched.length > 0 ?
      {
        height: '140px',
        flex: '1',
      } :
      {
        height: '220px',
        flex: '1',
      };
  }

  get value(): string {
    return this.searchValue;
  }

  set value(value) {
    this.searchValue = value;
  }

  get searchbarplaceholder(): string {
    // tslint:disable-next-line
    return `${this.$t('common.search').toString()} ${this.$t('workflow.dashboard.tenants').toString()}`;
  }

  get getAllCustomers(): string[] {
    return this.filteredCustomers.length > 0 ? this.filteredCustomers : ['No results to display'];
  }

  get getTotalPaginationIndices() {
    return this.totalPaginationIndices;
  }

  get recentlySearchedCustomers(): string[] {
    return this.recentlySearched;
  }

  setRecentlySearchedCustomers({ selectedVal, productGroupId }: any) {
    if (selectedVal !== defaultSelectedCustomer) {
      this.$store.commit('DropdownStoreModule/recentSearchManager', { selectedVal, productGroupId });
    }
    this.$emit('searchedCustomer', selectedVal);
  }

  created() {
    this.isLargeCustomer = this.$store.getters.isLargeCustomer;
    setTimeout(() => {
      this.paginateLargeCustomers(this.customersList);
      const wrapper2 = document.getElementById('searchTenant') as HTMLElement;
      if (wrapper2) {
        wrapper2.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         500);
  }
  handleSearchFilter() {
    // this.filteredCustomers = this.customersList.filter(each => typeof each !== 'string' && each.productGroupName.toLowerCase()
    // .indexOf(this.searchValue.toLowerCase()) > -1);
    // this.show50Records(this.customersList.filter(each => typeof each !== 'string' && each.productGroupName.toLowerCase()
    // .indexOf(this.searchValue.toLowerCase()) > -1));
    this.paginateLargeCustomers(this.customersList.filter(each => typeof each !== 'string' && each.productGroupName.toLowerCase()
    .indexOf(this.searchValue.toLowerCase()) > -1));
  }

  paginateLargeCustomers(list: any) {
    const paginated: any = [];

    if (list.length > 15) {
      this.showNextOrPrev = true;
      const maxNumberOfFullPages = list.length;
      for (let i = 0; i < maxNumberOfFullPages; i += 15) {
        const recordList = list.slice(i, i + 15);
        paginated.push(recordList);
      }
      this.paginated = paginated;
      this.filteredCustomers = paginated[this.currentPaginationIndex];
      this.totalPaginationIndices = this.paginated.length;
    } else {
      this.showNextOrPrev = false;
      this.filteredCustomers = list;
      this.paginated = list;
      this.currentPaginationIndex = 0;
      this.totalPaginationIndices = this.paginated.length;
    }
  }

  show50Records(list: any) {
    this.filteredCustomers = list.slice(0, 50);
  }

  changePage(left: boolean = false) {
    if (left) {
      this.currentPaginationIndex === 0 ? this.currentPaginationIndex = 0 : this.currentPaginationIndex -= 1;
    } else {
      if (this.currentPaginationIndex !== this.totalPaginationIndices - 1) this.currentPaginationIndex += 1;
    }
  }
}
